import { useState } from "react";

import { FileModel } from "@interfaces/index";
import { attachmentsService } from "@services/index";

import { useNotify } from "./useNotify";

export const useFileUpload = (onUploaded?: () => void) => {
  const notify = useNotify();
  const [files, setFiles] = useState<FileModel[]>([]);
  const [isUploading, setIsUploading] = useState(false);

  const selectFiles = async (target: HTMLInputElement) => {
    setIsUploading(true);
    if (!target.files?.length) {
      setIsUploading(false);
      return;
    }

    const newFiles = await attachmentsService.getAttachments(target.files);

    if (typeof newFiles === "string") {
      notify("error", newFiles);
      setIsUploading(false);
      return;
    }

    const newFilesWithSizes: FileModel[] = newFiles.map((file, index) => ({
      ...file,
      size: target.files?.[index]?.size || 0,
    }));
    setFiles((files) => [...files, ...newFilesWithSizes]);
    onUploaded?.();
    setIsUploading(false);
  };

  const removeFile = (uuid: string) => {
    setFiles((files) => files.filter((file) => file.uuid !== uuid));
  };

  return { files, setFiles, isUploading, selectFiles, removeFile };
};
